/* The bar retracts while the page scrolls down and comes back on the way up.
   Without this script the bar simply stays put (sticky), so nothing depends on it. */
(() => {
  const header = document.querySelector('.header');
  if (!header) return;
  const STEP = 8;
  let lastY = window.scrollY;
  let queued = false;

  const keepOpen = () =>
    header.querySelector('details[open]') ||
    header.contains(document.activeElement) ||
    header.matches(':hover') ||
    document.body.classList.contains('lfc-open');

  const update = () => {
    queued = false;
    const y = Math.max(window.scrollY, 0);
    const delta = y - lastY;
    if (y <= header.offsetHeight * 2 || keepOpen()) {
      header.classList.remove('is-retracted');
    } else if (delta > STEP) {
      header.classList.add('is-retracted');
    } else if (delta < -STEP) {
      header.classList.remove('is-retracted');
    }
    if (Math.abs(delta) > STEP) lastY = y;
  };

  window.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }, { passive: true });

  header.addEventListener('focusin', () => header.classList.remove('is-retracted'));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open], [data-search-open], [data-lfc-open]')) header.classList.remove('is-retracted');
  });
})();
